<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/proxy-hosting-info.html" name="c-proxy-hosting-info">
<link rel="ractive" href="../components/proxy-head.html" name="c-proxy-head">
<link rel="ractive" href="../components/proxy-request-bandwidth-stats.html" name="c-proxy-request-bandwidth-stats">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-header></c-header>
	<div class="p-proxy">
		{{#each ossCdnProjects}}
			<div class="proxy-wrapper">
				<div class="proxy-item">
					<c-proxy-head link="{{link}}" docsLink="{{docsLink}}" jsDelivrLink="{{jsDelivrLink}}">
						{{#partial title}}
							{{title}}
						{{/partial}}

						{{#partial descr}}
							{{descr}}
						{{/partial}}

						{{#partial img}}
							<img width="{{imgWidth}}" height="{{imgHeight}}" src="{{@shared.assetsHost}}{{imgSrc}}">
						{{/partial}}
					</c-proxy-head>

					<c-proxy-request-bandwidth-stats
							name="{{apiCdnName}}"
							periodData="{periodValue: 'month', periodText: 'month', periodType: 's-month'}"
							bandwidthUnit="GB">
					</c-proxy-request-bandwidth-stats>

					<div class="full-stats-link" class="btn-arrow">
						<a href="{{jsDelivrLink}}">
							<span>{{title}} full stats</span>
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg">
						</a>
					</div>
				</div>
			</div>
		{{/each}}

		<div class="proxy-info">
			<div class="divider"></div>

			<c-proxy-hosting-info></c-proxy-hosting-info>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	const ossCdnProjects = require('../../assets/json/oss-cdn-projects.json');

	component.exports = {
		data () {
			return {
				title: 'Custom CDN Endpoints - jsDelivr',
				description: 'jsDelivr is happy to support unique use-cases that require a fast CDN.',
				ossCdnProjects,
			};
		},
	};
</script>
